/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule, NbLayoutModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
  NbToggleModule,
  NbCardModule,
  NbSelectModule,
  NbSpinnerModule,
  NbButtonModule,
  NbRadioModule,
  NbCheckboxModule,
  NbInputModule,
  NbTooltipModule,
  NbTabsetModule,
} from '@nebular/theme';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';
import { CookieService } from 'ngx-cookie-service';
import { InscriptionComponent } from './inscription/inscription.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
//import { DialogModule } from 'primeng/dialog';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxImageZoomModule } from 'ngx-image-zoom';
import { UiSwitchModule } from 'ngx-ui-switch';



export function HttpLoaderFactory(http:HttpClient){
  return new TranslateHttpLoader(http);
}
import {CalendarModule, SplitButtonModule, DialogModule,AutoCompleteModule, InputSwitchModule} from "primeng/primeng";
import { CommonModule } from '@angular/common';
@NgModule({
  declarations: [AppComponent, InscriptionComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbToggleModule,
    ThemeModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    NbLayoutModule,
    AutocompleteLibModule,
    NbSpinnerModule,
    NbSelectModule,
    NbCardModule,
    NbButtonModule,
    FormsModule,
    ReactiveFormsModule,
    NbRadioModule,
    NgxIntlTelInputModule,
    CalendarModule,
    DialogModule,
    NbCheckboxModule,
    ReactiveFormsModule,
    FormsModule,
    AutocompleteLibModule,
    NgSelectModule,
    NbInputModule,
    NgxImageZoomModule.forRoot(),
    NbTooltipModule,
    NbTabsetModule,
    UiSwitchModule.forRoot({ 
    }),
    NbToggleModule,
    CommonModule,
  ],
  bootstrap: [AppComponent],
  providers: [CookieService]
})
export class AppModule {
}
